import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { TResponse } from "../../../types/common";
import { DashboardStatsResponse } from "../../../types/api/dashboard";
import { dashboardDetails } from "./callbacks";

export const useDashboardDetails = (
  options?: Omit<
    UseQueryOptions<TResponse<DashboardStatsResponse>, Error>,
    "queryKey" | "queryFn"
  >
): UseQueryResult<TResponse<DashboardStatsResponse>, Error> => {
  return useQuery<TResponse<DashboardStatsResponse>, Error>({
    queryKey: [API_ENDPOINTS.DASHBOARD_STATS],
    queryFn: async () => {
      const res = await dashboardDetails();
      return res.data;
    },
    refetchOnWindowFocus: false,
    staleTime: 300000,
    ...options,
  });
};
